<template>
  <div class="w-full bg-white height-100">
    <!-- <el-dialog class="ne-oppop" width="70%" :visible.sync="popupnew" center>
      <CreateSmsTemplate />
    </el-dialog> -->
    <el-dialog
      class="ne-oppop"
      width="35%"
      :visible.sync="centerDialogVisiblehh"
      center
    >
      <div class="bg-primary p-4 flex justify-between items-center">
        <h2 class="text-white fsize14 my-0">Whatsapp Campaign</h2>
        <feather-icon
          icon="XIcon"
          svgClasses="w-4 h-4"
          class="cursor-pointer text-white"
          @click="centerDialogVisiblehh = false"
        />
      </div>

      <div class="flex justify-center mt-3 pb-4 px-4 w-full items-center">
        <div class="">
          <div class="flex justify-center mb-6">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
              class="new-height"
            />
          </div>
          <div class="text-center">
            <h1 class="fsize20 text-dark font-semibold">
              SenderID has been Successfully submitted
            </h1>
            <p class="fsize14 text-gray my-2">
              Please Callback after 24 hours after submission
            </p>
            <vs-button
              color="success"
              class="px-4 mt-2 bg-success border-0 text-white font-normal fsize14"
            >
              <a href="https://gupshup.io" class="text-white" target="_blank"
                >Click here to setup</a
              >
            </vs-button>
            <p class="cursor-pointer mt-3 mb-4">
              Is your whatsapp already setup?<a
                @click="
                  () => {
                    centerDialogVisiblehh = false;
                    newSenderIdPopup = true;
                    errors.clear();
                  }
                "
                >click here</a
              >
            </p>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="isShowNewSegment" width="50%" center>
      <div slot="title">
        <h2 class="font-semibold fsize16 text-white">Add New Segment</h2>
      </div>
      <div>
        <AddSegmentTable @handleAddNewSegment="handleAddNewSegment" />
      </div>
    </el-dialog>

    <el-dialog :visible.sync="newSenderIdPopup" width="30%" center>
      <div slot="title">
        <h2 class="font-semibold fsize14 text-white">Add New Segment</h2>
      </div>
      <div class="flex items-center w-full">
        <div class="w-full">
          <div class="mb-4">
            <label class="font-medium">Phone Number</label>

            <el-input
              placeholder="Please input"
              class="mt-1"
              v-model="mobile"
              maxlength="10"
              v-validate="'required|numeric|max:10'"
              name="mobile"
              data-vv-validate-on="input|blur"
            ></el-input>
            <p v-if="errors.has('mobile')" class="text-danger fsize12 mt-1">
              {{ errors.first("mobile") }}
            </p>
          </div>
          <div class="mb-4">
            <div class="mt-2">
              <div class="mb-4">
                <label class="font-medium">Auth key</label>
                <el-input
                  data-vv-validate-on="input|blur"
                  placeholder="Please input"
                  class="mt-1"
                  maxlength="50"
                  v-model="authKey"
                  v-validate="'required'"
                  name="authKey"
                ></el-input>
                <p
                  v-if="errors.has('authKey')"
                  class="text-danger fsize12 mt-1"
                >
                  {{ errors.first("authKey") }}
                </p>
              </div>
              <div class="mb-4">
                <label class="font-medium">Sender ID</label>
                <el-input
                  data-vv-validate-on="input|blur"
                  placeholder="Please input"
                  class="mt-1"
                  v-model="sender"
                  v-validate="'required|max:6'"
                  name="sender"
                ></el-input>
                <p v-if="errors.has('sender')" class="text-danger fsize12 mt-1">
                  {{ errors.first("sender") }}
                </p>
              </div>
              <div class="mb-2">
                <label class="font-medium">Entity ID</label>
                <el-input
                  data-vv-validate-on="input|blur"
                  placeholder="Please input"
                  v-validate="'required'"
                  class="mt-1"
                  maxlength="50"
                  v-model="entity"
                  name="entity"
                ></el-input>
                <p v-if="errors.has('entity')" class="text-danger fsize12 mt-1">
                  {{ errors.first("entity") }}
                </p>
              </div>
              <div class="mt-2">
                <p class="fsize12 col-4f">
                  For support, contact
                  <span class="text-primary font-semibold"
                    >support@brained.app</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="flex gap-4 justify-center mt-6 items-center">
            <vs-button
              class="bg-gtr rounded-lg border-0 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 w-full sm-fsize14"
              @click="createSmsConfig"
            >
              Submit
            </vs-button>
            <vs-button
              @click="changes()"
              type="secondary"
              class="bg-secondary rounded-lg border-0 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 w-full sm-fsize14"
            >
              Cancel
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="handleCreateSegment"
      width="50%"
      class="ishidePopup"
      center
    >
      <div>
        <div>
          <el-radio class="lbl-plrem" v-model="isShowSegment" label="1"
            >Send Individually</el-radio
          >
          <el-radio class="lbl-plrem" v-model="isShowSegment" label="2"
            >Send by Segment</el-radio
          >
        </div>
        <div class="relative mt-6">
          <el-input
            v-model="searchInput"
            maxlength="50"
            placeholder="Enter Search..."
            class="rounded-xl"
          />
        </div>

        <div class="mt-8">
          <div v-if="isShowSegment === '1'">
            <SendIndividuallyTable
              :search="searchInput"
              @segmentsIndividual="segmentsIndividual"
              @handleCreateSegmentPopup="handleCreateSegmentPopup"
            />
          </div>

          <div v-if="isShowSegment === '2'">
            <SendBySegment
              :search="searchInput"
              @segments="segments"
              @handleCreateSegmentPopup="handleCreateSegmentPopup"
            />
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="centerDialogVisible"
      custom-class="ishidePopup rounded-10px"
      width="30%"
      center
    >
      <div class="flex justify-center items-center">
        <div>
          <div class="flex justify-center">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
              class="w-32 h-32"
            />
          </div>
          <div class="text-center mt-4">
            <h4 class="font-semibold text-dark text-2xl">
              You Need more SMS Credits
            </h4>
            <p class="fsize12 text-black pt-1">
              The Campaign is set to target
              <span class="text-primary font-semibold"> 1000</span> audience.
              need <span class="text-primary font-semibold"> 100</span> more
              email credits to run this Campaign
            </p>
          </div>
          <div class="flex gap-4 justify-center mt-6 items-center">
            <vs-button
              type="success"
              class="bg-success rounded-full text-white font-medium fsize14 py-12px px-6"
              @click="handleClick('Add-ons')"
            >
              By more sms credits
            </vs-button>
            <vs-button
              type="primary"
              @click="centerDialogVisible = false"
              class="bg-primary rounded-full text-white font-medium fsize14 py-12px px-6"
            >
              Edit Target audience
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="isShowCampaignPopup"
      custom-class="ishidePopup"
      width="30%"
      center
    >
      <div class="">
        <div class="block">
          <div>
            <span class="demonstration text-dark font-semibold"
              >Pick a Date & Time</span
            >
          </div>
          <el-date-picker
            v-model="datepick"
            type="date"
            placeholder="Pick a date"
            class="mt-3 w-full"
          >
          </el-date-picker>
        </div>
        <p class="text-8f8f8f fsize12 mt-2">
          You can alwys change the schedule later by visting your planner before
          the event goes live.
        </p>

        <el-divider class="text-primary font-semibold">OR</el-divider>
        <div>
          <div class="flex items-center">
            <input type="checkbox" class="cust-check" />
            <p class="pl-2 mb-0 text-dark font-semibold">Start it Instantly</p>
          </div>
          <p class="text-8f8f8f fsize12 mt-1">
            Link a specific page or a website you'd like to inclide in your
            campaign
          </p>
        </div>

        <div class="flex gap-4 justify-center mt-6 items-center">
          <vs-button
            type="primary"
            class="bg-primary w-1/2 rounded-full text-white font-medium fsize14 py-12px px-6"
          >
            Confirm Campaign
          </vs-button>
          <vs-button
            type="secondary"
            class="bg-secondary w-1/2 rounded-full text-white font-medium fsize14 py-12px px-6"
          >
            Cancel
          </vs-button>
        </div>
      </div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl font-semibold">
            Create a SMS Campaign
          </h2>
        </div>
      </div>
    </div>
    <div class="bg-white menucontrol-scroll fixed-top px-6 py-8">
      <div class="flex w-full items-start">
        <div class="w-2/5 pr-12">
          <div class="relative text-center">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Assets/sms.svg"
              alt="sms"
              class="width-sms2"
            />
            <div class="absolute top-0 left-0 right-0">
              <div
                class="width-smss flex justify-center mx-auto items-start pl-6 pr-6"
              >
                <div class="flex items-center h-full">
                  <div class="mb-100px wid-mobiless">
                    <div class="text-center">
                      <small class="text-dark">{{ dateFormat }}</small>
                    </div>
                    <div class="mt-4 rounded-10px bg-e5 text-right py-4 px-6">
                      <p class="text-dark fsize12 start-text">
                        {{
                          smsbody.smsBody
                            ? smsbody.smsBody
                            : "Note:You can use dynamic tags to fetch info like names,companies & contact info."
                        }}
                        <br />
                        <a :href="smsbody.url" class="col-61">
                          {{
                            smsbody.url
                              ? smsbody.url
                              : "https://projectbrained.app/asjahfo"
                          }}</a
                        >
                      </p>
                    </div>
                    <div class="text-right pt-1">
                      <small class="text-dark">{{ timeFormat }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <p class="fsize12 col-4f">
                Note: The appearence of the text message may vary <br />based on
                the style preference on diffrent device.
              </p>
            </div>
          </div>
        </div>
        <div class="w-3/5 bg-white lg:pb-32 relative">
          <div class="grid grid-cols-2 gap-8">
            <div>
              <div>
                <h6 class="col-4f text-xl mb-1 font-semibold">
                  Give a title to this Campaign
                </h6>

                <el-input
                  placeholder="Please Add Campaign Title"
                  class="mt-3 w-full"
                  maxlength="50"
                  v-model="title"
                ></el-input>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{
                    title === "" || title[0].trim() === ""
                      ? "This Field is required"
                      : ""
                  }}
                </p>
              </div>
              <div class="mt-6">
                <h6 class="col-4f text-xl mb-1 font-semibold">Sender ID</h6>

                <el-select
                  v-model="value2"
                  placeholder="Sender ID"
                  class="w-full mt-2"
                  value-key="_id"
                >
                  <!-- <el-option label="Create Sender Id" value="new"> </el-option> -->
                  <el-option
                    v-for="item in smsConfig"
                    :key="item._id"
                    :label="item.sender"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ value2 === "" ? "This Field is required" : "" }}
                </p>
              </div>

              <div class="mt-4 w-full">
                <p
                  class="w-full text-success flex items-center gap-2 cursor-pointer text-white font-semibold fsize14"
                  @click="
                    () => {
                      newSenderIdPopup = true;
                    }
                  "
                >
                  <feather-icon icon="PlusIcon" svgClasses="w-5 h-5" />Create
                  New SenderID
                </p>
              </div>
              <div class="mt-6">
                <h6 class="col-4f text-xl mb-1 font-semibold">
                  Select Template
                </h6>

                <el-select
                  filterable
                  v-model="smsbody"
                  placeholder="Select Template"
                  class="w-full mt-2"
                  value-key="_id"
                  :disabled="!value2"
                >
                  <el-option
                    v-for="item in data.sms"
                    :key="item._id"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ smsbody === "" ? "This Field is required" : "" }}
                </p>
                <el-divider>or</el-divider>
                <p
                  class="w-full mt-2 text-success flex items-center gap-2 cursor-pointer text-white font-semibold fsize14"
                  @click="handleSend('marcom-SMSTemplate')"
                >
                  <!-- <p
                  class="w-full mt-2 text-success flex items-center gap-2 cursor-pointer text-white font-semibold fsize14"
                  @click="popupnew = true"
                > -->
                  <feather-icon icon="PlusIcon" svgClasses="w-5 h-5" />Create
                  New Template
                </p>
              </div>
            </div>
            <div>
              <!-- <div class="">
                <h6 class="col-4f text-xl mb-1 font-semibold">Attach a URL</h6>
                <p class="text-8f8f8f fsize12 mb-0">
                  Link a specific page or a website you'd like to include in
                  your Campaign.
                </p>
                <el-input
                  placeholder="Please input"
                  class="mt-3 w-full "
                  v-model="input"
                ></el-input>
              </div> -->
              <!-- <div class="mt-6">
                <h6 class="col-4f text-xl mb-1 font-semibold">Enter PE ID</h6>
                <p class="text-8f8f8f fsize12 mb-0">
                  Enter your 19 digit PE ID
                </p>
                <el-input
                  placeholder="Please input"
                  class="mt-3 w-full "
                  v-model="input"
                ></el-input>
              </div> -->

              <div>
                <h6 class="col-4f text-xl mb-1 font-semibold">
                  Select Target Segment
                </h6>

                <div
                  class="flex flex-wrap border mt-4 p-3"
                  @click="handleCreateSegment = true"
                >
                  <el-tag
                    v-show="
                      segmentSelected.length !== 0 && segmentsIndi.length !== 0
                    "
                    v-for="item in segmentSelected"
                    :key="item._id"
                    :label="item.label"
                    :value="item.name"
                    closable
                    @close="handleClose(item._id)"
                    class="mb-2 mr-2 rounded-4px bg-primary text-white fsize10"
                    >{{ item.name }}</el-tag
                  >
                  <p
                    v-show="uniqueSegment.length === 0"
                    class="text-8f8f8f fsize12 mb-0"
                  >
                    Select Target Segment
                  </p>
                </div>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{
                    segmentSelected.length === 0 || uniqueSegment.length === 0
                      ? "This Field is required"
                      : ""
                  }}
                </p>
              </div>
              <el-divider>or</el-divider>
              <div class="my-6">
                <div
                  @click="isShowNewSegment = true"
                  class="rounded-md cursor-pointer flex gap-2 rounded-4px"
                >
                  <div class="flex items-center gap-2">
                    <feather-icon
                      icon="PlusIcon"
                      svgClasses="w-5 h-5"
                      class="text-success"
                    />
                    <p class="text-success font-semibold fsize14 mb-0">
                      Create New Segment
                    </p>
                  </div>
                </div>
              </div>
              <div class="flex justify-between w-full mt-2">
                <div class="flex gap-2 items-center">
                  <p class="col-4f mb-0 fsize12 font-medium">TG Size:</p>
                  <p class="text-primary mb-0 fsize12 font-semibold">
                    {{
                      segmentSelected || uniqueSegment
                        ? segmentSelected.length || uniqueSegment.length
                        : 2000
                    }}
                  </p>
                </div>
                <div class="flex gap-2 items-center">
                  <p class="col-4f fsize12 mb-0 font-medium">SMS Credits:</p>
                  <p class="text-primary fsize12 mb-0 font-semibold">
                    {{ myAddonsData ? myAddonsData.quantity : 0 }}
                  </p>
                </div>
              </div>

              <div
                class="mt-6 bg-f4f5f6 p-4 rounded-6px"
                v-if="this.myAddonsData.quantity <= 100"
              >
                <h3 class="font-semibold col-4f text-xl">Resources</h3>
                <div class="flex items-center mt-4 w-full">
                  <div class="flex gap-2 items-center">
                    <img
                      src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/sms.svg"
                      class="object-contain"
                      alt="banh"
                    />

                    <div class="mt-2 pl-4">
                      <h2 class="font-semibold mb-0 col-4f text-lg">
                        x 15000 SMS Credits
                      </h2>
                      <p class="fsize12 mt-0 col-4f">You have SMS Credits</p>
                    </div>
                  </div>
                </div>

                <div class="w-full mt-4">
                  <vs-button
                    color="success"
                    @click="handleClick('Add-ons')"
                    class="w-full bg-success border-0 text-white font-normal fsize14"
                  >
                    Buy More
                  </vs-button>
                </div>
              </div>
              <!-- <div class="mt-6">
                <h6 class="col-4f text-xl mb-1 font-semibold">Pick a Template</h6>
                <p class="text-8f8f8f fsize12 mb-0">
                  Select a layout for your email
                </p>
                <div class="grid grid-cols-2 gap-4 mt-2">
                  <div>
                    <img
                      src="@/assets/images/frag.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag2.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag3.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag4.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="absolute bottom-0 right-0">
            <!-- <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/pinkgo.png"
                class=""
              />
            </div> -->
            <div class="bg-primary w-24 h-24 rounded-full cursor-pointer">
              <div
                class="flex justify-center items-center w-24 h-24"
                @click="onClick()"
              >
                <feather-icon
                  icon="ArrowRightIcon"
                  svgClasses="w-10 h-10"
                  class="text-white flex"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import AddSegmentTable from "./components/AddSegmentTable";
// import VueEllipseProgress from "vue-ellipse-progress";
import SendBySegment from "./components/SendBySegment.vue";
import SendIndividuallyTable from "./components/SendIndividuallyTable.vue";
// import CreateSmsTemplate from "./CreateSmsCampaign.vue";
export default {
  data() {
    return {
      data: [],
      centerDialogVisible: false,
      centerDialogVisiblehh: false,
      isShowNewSegment: false,
      newSenderIdPopup: false,
      textarea2: "",
      multipleSegmentSelected: [],
      mobile: "",
      authKey: "",
      sender: "",
      entity: "",
      datepick: "",
      segmentSelected: [],
      seletedIndividual: [],
      targetSegmentSelect: [],
      isShowCampaignPopup: false,
      popupnew: false,
      handleCreateSegment: false,
      isShowSegment: "1",
      segmentData: [],
      segmentsAdded: [],
      segmentsIndi: [],
      value: "",
      value2: "",
      sendingData: {},
      smsConfig: [],
      uniqueSegment: [],
      getIndexId: "",
      number: [],
      myAddonsData: [],
      smsbody: "",
      title: "",
      input: "",
      date: "",
      searchInput: "",
      submitted: false,
    };
  },
  computed: {
    ...mapState("admin", ["myAddOns", "login"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("marcom", ["taskListUsers"]),
    dateFormat() {
      return moment().format("ddd, MMMM DD");
    },
    timeFormat() {
      return moment().format("HH:mm a");
    },
  },
  components: {
    SendBySegment,
    SendIndividuallyTable,
    AddSegmentTable,
    // CreateSmsTemplate,
  },
  watch: {
    value2(value) {
      value == "new"
        ? (this.newSenderIdPopup = true)
        : (this.newSenderIdPopup = false);
      if (value) {
        this.getSmsTemplates(value);
      }
    },
    title() {
      this.whitespaceRemove();
    },

    // newSenderIdPopup(value) {
    //   if (!value) {
    //     this.value2 = "";
    //     this.mobile = "";
    //   } else {
    //     this.mobile = this.login.mobile;
    //   }
    // },
  },
  methods: {
    handleSend(name) {
      this.$router.push({ name: name });
    },
    handleClose(id) {
      this.segmentSelected.splice(
        this.segmentSelected.findIndex((x) => x._id === id),
        1
      );
    },
    DateOneYear(date) {
      console.log(date, "AnishKhot");
      let currentDate = new Date(date);
      currentDate.setFullYear(currentDate.getFullYear() + 1);
      return currentDate;
    },
    whitespaceRemove() {
      this.$el.addEventListener("input", () => {
        this.title = this.title ? this.title.trimStart() : "";
      });
    },
    handleAddNewSegment() {
      this.isShowNewSegment = false;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async onClick() {
      // this.segmentSelected.forEach((element) => {
      //   const { user } = this.segmentSelected.concat(element.audienceId._id);
      //   this.uniqueSegment = new Set([...user]);
      // });
      // console.log(this.uniqueSegment, this.number);
      // (this.sendingData = {
      //   value: this.value,
      //   value2: this.value2,
      //   segmentSelected: [this.uniqueSegment],
      //   number: this.number,
      // }),
      //   console.log(this.sendingData, "yooo");
      this.submitted = true;
      if (this.myAddonsData.quantity < this.segmentSelected.length) {
        this.centerDialogVisible = true;
      } else {
        let audienceData = [];
        if (this.segmentsAdded.length) {
          this.segmentsAdded.forEach((data) => {
            data.audienceId.forEach((audience) => {
              const { _id, mobile } = audience;
              if (mobile) {
                let parsedmobile = Number(mobile);
                audienceData.push({ _id, mobile: parsedmobile });
              }
              // console.log(audience);
            });
          });
        }
        if (this.segmentsIndi.length) {
          this.segmentsIndi.forEach((data) => {
            const { _id, mobile } = data;
            if (mobile) {
              let parsedmobile = Number(mobile);
              audienceData.push({ _id, mobile: parsedmobile });
            }
          });
        }
        let filtered = audienceData.filter(function ({ _id, mobile }) {
          let key = `${_id}${mobile}`;
          return !this.has(key) && this.add(key);
        }, new Set());
        this.uniqueSegment = filtered;
        // console.log("uniqueSegment :", this.uniqueSegment);

        if (this.uniqueSegment.length === 0) {
          this.segmentSelected.forEach((data) => {
            const { _id, mobile } = data;
            if (mobile) {
              let parsedmobile = Number(mobile);
              this.uniqueSegment.push({ _id, mobile: parsedmobile });
            }
            // console.log(data);
          });
        }
        if (
          this.title !== "" &&
          this.value2 !== "" &&
          this.smsbody !== "" &&
          this.segmentSelected.length !== 0
        ) {
          this.$swal
            .fire({
              title: "Alert",
              text: `Are you sure you want to proceed with the selected data, Selected Template will be sent to ${
                filtered.length == 1
                  ? "1 user"
                  : filtered.length + " " + "users"
              }`,
              icon: "warning",
              confirmButtonText: "Yes, Continue",
              cancelButtonText: "Cancel",
              showCancelButton: true,
              confirmButtonColor: "#EA4Dff",
              cancelButtonColor: "  #6e7881",
            })
            .then(async (result) => {
              if (result.isConfirmed) {
                this.sendingData = {
                  title: this.title,
                  template: this.smsbody,
                  sender: this.value2,
                  uniqueUser: this.uniqueSegment,
                  // segment: this.segmentSelected,
                };
                // console.log(this.sendingData);
                // console.log(this.myAddonsData.quantity);

                try {
                  let data = await this.$store.dispatch(
                    "smsCampaign/createSmsCampaign",
                    this.sendingData
                  );
                  if (data.code == 200 && data.data.code != 101) {
                    console.log(data);
                    this.submitted = false;
                    (this.title = ""),
                      (this.smsbody = ""),
                      (this.value2 = ""),
                      (this.uniqueSegment = ""),
                      (this.segmentSelected = "");
                    const res = await this.$swal({
                      icon: "success",
                      title: "SMS Campaign Created Successfully",
                      showConfirmButton: true,
                    });
                  } else {
                    await this.$swal({
                      icon: "warning",
                      title: "Campaign name already exists",
                      showConfirmButton: true,
                    });
                  }
                  // console.log(res, "RES");
                  // console.log(data);
                } catch (err) {
                  console.log(err);
                }
              }
            });

          // if (this.segmentSelected.length > this.myAddonsData.quantity) {
          //   console.log(this.segmentSelected.length, "greater than");
          //   this.centerDialogVisible = true;
          // } else if (this.segmentSelected.length < this.myAddonsData.quantity) {
          //   console.log(this.segmentSelected.length, "less than");
          //   this.centerDialogVisible = false;
          //   this.$router.push({ path: "/admin-panel/add-ons" });
          // }

          // if (!this.myAddonsData.quantity.isEmpty) {
          //   this.myAddonsData.quantity =
          //     this.myAddonsData.quantity - this.segmentSelected.length;
          //   this.$router.push({ path: "/admin-panel/marcom" });
          //   console.log(this.myAddonsData.quantity);
          // } else if (this.myAddonsData.quantity.isEmpty) {
          //   console.log("quantity is empty");
          // }
        }
      }
    },

    async getSmsTemplates(sender) {
      this.data = await this.$store.dispatch("smsCampaign/getSmsTemplate", {
        senderId: sender._id,
      });
      console.log(data);
    },
    async getAllSegments() {
      try {
        let data = await this.$store.dispatch("segment/getAllSegment");
        this.segmentData = data.data;
        console.log(data);
      } catch (err) {
        console.log(err);
      }
    },

    async createSmsConfig() {
      let payload = {
        type: "sms",
        mobile: this.mobile,
        projectId: this.selectedProject._id,
        authKey: this.authKey,
        sender: this.sender,
        dltId: this.entity,
        user: this.taskListUsers.PM[0]._id,
      };

      this.$validator.validateAll().then(async (result) => {
        if (result) {
          let data = await this.$store.dispatch(
            "smsCampaign/createSmsConfig",
            payload
          );
          this.newSenderIdPopup = false;
          if (data) {
            this.$swal({
              text: "Sender ID Created Successfully",
              icon: "success",
              confirmButtonColor: "#830c81",
              confirmButtonText: "Okay",
            });
            this.authKey = "";
            this.sender = "";
            this.entity = "";
            this.mobile = "";
          }
        }
      });
    },

    async getSmsConfig() {
      let data = await this.$store.dispatch("smsCampaign/getSmsConfig", {
        projectId: this.selectedProject._id,
      });
      this.smsConfig = data;
      // this.smsConfig.unshift({
      //   _id: "new",
      //   sender: "Create New SenderID",
      // });
      // console.log(data);
    },
    segments(segments) {
      this.segmentSelected = segments;
      this.segmentsAdded = segments;
      this.handleCreateSegmentPopup();
    },
    segmentsIndividual(segmentsIndividual) {
      this.segmentSelected = segmentsIndividual;
      this.segmentsIndi = segmentsIndividual;
      this.handleCreateSegmentPopup();
    },
    handleCreateSegmentPopup() {
      this.handleCreateSegment = false;
    },
    changes() {
      this.newSenderIdPopup = false;
      this.value2 = "";
    },
    async getAllmyAddons() {
      let smsAddOns = {};
      for (let i of this.myAddOns) {
        if (i.addOnId.flag == "P_SMS") {
          smsAddOns = i;
        }
      }
      this.myAddonsData = smsAddOns;
    },

    downloadPdf() {
      this.createSmsConfig();
      window.open(`${this.$imageURL}/brained/admin/sms_setup/SMS%20Setup.zip`);
      this.newSenderIdPopup = false;
    },
  },
  async mounted() {
    // this.getSmsTemplates();
    this.DateOneYear();
    this.getAllSegments();
    this.getSmsConfig();
    this.getAllmyAddons();
    console.log(this.login);
  },
};
</script>
<style>
.el-radio__input.is-checked .el-radio__inner {
  border-color: #cd3197 !important;
  background: #cd3197 !important;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #cd3197 !important;
}
.lbl-plrem {
  padding-left: 0px !important;
}
.el-tag .el-tag__close {
  color: #ffffff !important;
}
</style>
